import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Link from '@ux/link';
import { golf } from './enums';

export function Links(props) {
  if (props.preset === 'internal-header') return null;
  const { eids } = props;
  const isType3 = props.privateLabelType === 3;

  const links = [
    (!isType3 || (props.resellerUrls && props.resellerUrls.products)) && (
      <Link
        className='customer-link'
        key='products'
        href={ props.urls.products.href }
        data-eid={ eids.products }>
        <FormattedMessage id={ golf.products } />
      </Link>
    ),
    !isType3 && (
      <Link
        className='customer-link'
        key='renewals'
        href={ props.urls.renewals.href }
        data-eid={ eids.renewals } >
        <FormattedMessage id={ golf.renewals } />
      </Link>
    ),
    (!isType3 || (props.resellerUrls && props.resellerUrls.account)) && (
      <Link
        className='customer-link'
        key='account'
        href={ props.urls.account.href }
        data-eid={ eids.accountSettings }>
        <FormattedMessage id={ golf.accountSettings } />
      </Link>
    )
  ].filter(Boolean);

  if (props.privateLabelId === 1 && props.bottomLinks.length > 0) {
    links.push(<div className='tray-menu-divider' key='resourcesDivider' />);
    props.bottomLinks.forEach((link, i) => {
      if (link) {
        links.push(
          <Link
            { ...link }
            urlArgs={ props.urlArgs }
            key={ 'bottomLinks' + i }
            className='customer-link bottom-link'
          />
        );
      }
    });
  }

  return links;
}

Links.propTypes = {
  eids: PropTypes.shape({
    products: PropTypes.string,
    renewals: PropTypes.string,
    accountSettings: PropTypes.string
  }),
  privateLabelType: PropTypes.number,
  privateLabelId: PropTypes.number,
  preset: PropTypes.string,
  resellerUrls: PropTypes.object,
  urls: PropTypes.object,
  urlArgs: PropTypes.object,
  bottomLinks: PropTypes.arrayOf(PropTypes.object)
};

export default Links;
